import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { brandListerActions } from '../redux/brandLister/actions/BrandListerActions';
import { makeGetBrandListerItems, makeGetBrandListerFilters, } from '../redux/brandLister/selectors/BrandListerSelectors';
import { BrandListerFilters } from '../components/brand-lister/brand-lister-filters/BrandListerFilters';
import { BrandLister } from '../components/brand-lister/brand-lister/BrandLister';
const BrandListerContainer = props => {
    const dispatch = useDispatch();
    const items = useSelector(makeGetBrandListerItems());
    const filters = useSelector(makeGetBrandListerFilters());
    const handleClick = (filter) => {
        dispatch(brandListerActions.createSetFilterAction(filter));
    };
    return (_jsxs(_Fragment, { children: [_jsx(BrandListerFilters, { onClick: handleClick, filters: filters }), _jsx(BrandLister, { items: items })] }));
};
export default BrandListerContainer;
